import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  getMaxDate(): string {
    const today = new Date();
    return today.toISOString().split('T')[0];
  }

  isDateBeforeToday(date: Date): boolean {
    const today = new Date();
    return date < today && date >= new Date('1870-01-01');
  }
}
